export const tournamentLevel: { [key: string]: string } = {
  G: 'Grand Slam',
  M: 'ATP Masters',
  A: 'ATP',
  D: 'Davis Cup',
};



// WEBPACK FOOTER //
// ./src/app/constants/tournament-levels.ts